module.exports = __webpack_public_path__ + "img/logo-lite.28be79df.svg";